module.exports = __webpack_public_path__ + "static/media/storepreviewStoreFour.e03817ec.svg";